module.exports = __webpack_public_path__ + "static/virtual-reality-development-tijuana-mexico-b5360cbc5451ecf9634e16d0b7dddce0.jpg";